<button (click)="copyToClipboard(copyValue, $event)" *ngIf="size !== 'micro'" class="btn btn-secondary {{size}} nowrap" type="button">
  <span *ngIf="showCopiedMessage"><i class="fa-solid fa-clipboard-check"></i> Copied</span>
  <span *ngIf="!showCopiedMessage">Copy</span>
  <span *ngIf="size !== 'mini'"> to clipboard</span>
</button>
<button (click)="copyToClipboard(copyValue, $event)" *ngIf="size === 'micro'" class="btn btn-secondary small-icon" type="button">
  <span *ngIf="showCopiedMessage"><i class="fa-solid fa-clipboard-check"></i></span>
  <span *ngIf="!showCopiedMessage"><i class="far fa-clipboard"></i></span>
</button>
